import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function FloatingBackButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const path = location.pathname;
    // Bloquear en formularios de AttendanceForm
    const isAttendanceForm = /^\/attendance\/(institucional|personal)\/[^/]+\/(new|edit|copy)/.test(path);
    if (isAttendanceForm) {
      setVisible(false);
      return;
    }

    // Por defecto: solo aparece si existe .back-button en el DOM
    const updateVisibility = () => {
      setVisible(!!document.querySelector('.back-button'));
    };

    updateVisibility();

    const observer = new MutationObserver(updateVisibility);
    observer.observe(document.body, {
      subtree: true,
      childList: true
    });

    return () => observer.disconnect();
  }, [location]);

  if (!visible) return null;

  const fallback = (path) => {
    if (path.startsWith('/attendance/institucional')) {
      navigate('/classes/institucional', { replace: true });
    } else if (path.startsWith('/attendance/personal')) {
      navigate('/classes/personal', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  };

  const handleBack = () => {
    const currentPath = window.location.pathname;

    if (window.history.length > 1) {
      navigate(-1);

      // Si no cambia de ruta, aplica fallback
      setTimeout(() => {
        if (window.location.pathname === currentPath) {
          fallback(currentPath);
        }
      }, 60);
      return;
    }

    // Sin historial previo
    fallback(currentPath);
  };

  return (
    <button
      className="fab-back-button"
      onClick={handleBack}
      aria-label="Volver"
    >
      ←
    </button>
  );
}